export default "__VITE_ASSET__CLSsPVFu__"